module.exports = __webpack_public_path__ + "static/media/img-article-wfh.17fad1fe.png";